<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.46967 2.96967C7.76256 2.67678 8.23744 2.67678 8.53033 2.96967L13.0303 7.46967C13.3232 7.76256 13.3232 8.23744 13.0303 8.53033C12.7374 8.82322 12.2626 8.82322 11.9697 8.53033L8.75 5.31066V17C8.75 17.4142 8.41421 17.75 8 17.75C7.58579 17.75 7.25 17.4142 7.25 17V5.31066L4.03033 8.53033C3.73744 8.82322 3.26256 8.82322 2.96967 8.53033C2.67678 8.23744 2.67678 7.76256 2.96967 7.46967L7.46967 2.96967ZM17 7.25C17.4142 7.25 17.75 7.58579 17.75 8L17.75 19.6893L20.9697 16.4697C21.2626 16.1768 21.7374 16.1768 22.0303 16.4697C22.3232 16.7626 22.3232 17.2374 22.0303 17.5303L17.5303 22.0303C17.3897 22.171 17.1989 22.25 17 22.25C16.8011 22.25 16.6103 22.171 16.4697 22.0303L11.9697 17.5303C11.6768 17.2374 11.6768 16.7626 11.9697 16.4697C12.2626 16.1768 12.7374 16.1768 13.0303 16.4697L16.25 19.6893L16.25 8C16.25 7.58579 16.5858 7.25 17 7.25Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgSort',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>